var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngPrev(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 7,
    height: 12.25,
    viewBox: "0 0 7 12.25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Symbol",
    d: "M6.125 12.25C5.88802 12.25 5.67839 12.168 5.49609 12.0039L0.246094 6.75391C0.0820312 6.57161 0 6.36198 0 6.125C0 5.88802 0.0820312 5.67839 0.246094 5.49609L5.49609 0.246094C5.67839 0.0820312 5.88802 0 6.125 0C6.36198 0 6.57161 0.0820312 6.75391 0.246094C6.91797 0.428385 7 0.638021 7 0.875C7 1.11198 6.91797 1.32161 6.75391 1.50391L2.10547 6.125L6.75391 10.7461C6.91797 10.9284 7 11.138 7 11.375C7 11.612 6.91797 11.8216 6.75391 12.0039C6.57161 12.168 6.36198 12.25 6.125 12.25V12.25V12.25",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngPrev);
export default __webpack_public_path__ + "static/media/eng-prev.8ec52b9f733264cc9e7cf49635f98767.svg";
export { ForwardRef as ReactComponent };